import { useMemo } from "react";
import { EditButtonIcon, } from "ui/components/elements/edit-buttons/edit-buttons";
import { CameraViewId } from "3d/types";
import { useAppDispatch, useAppSelector, selectors, actions } from "store";
import { NodeComponentType } from "store/types";
export var useNodeActions = function (node) {
    var dispatch = useAppDispatch();
    var isZoomedIn = useAppSelector(selectors.selectIsZoomedIn(node.id));
    var canAddGripPosition = useAppSelector(selectors.selectCanAddGripPosition);
    var canAddCentralizedPump = useAppSelector(selectors.selectCanAddCentralizedPump);
    var canAddTubeConnection = useAppSelector(selectors.selectCanAddTubeConnection);
    var cupFill = useAppSelector(selectors.selectCupFill);
    var cameraViewId = useAppSelector(selectors.selectCameraViewId);
    var canDuplicate = useMemo(function () {
        if (node.type === NodeComponentType.GRIP_POSITION) {
            return canAddGripPosition;
        }
        else if (node.type === NodeComponentType.CENTRALIZED_VACUUM_PUMP) {
            return canAddCentralizedPump;
        }
        else if (node.type === NodeComponentType.TUBE_CONNECTION) {
            return canAddTubeConnection;
        }
        else {
            return false;
        }
    }, [
        node.type,
        canAddGripPosition,
        canAddCentralizedPump,
        canAddTubeConnection,
    ]);
    /* The fill tool previews on the flat 2D view, so it is not offered in 3D. */
    var canFillArea = canDuplicate &&
        node.type === NodeComponentType.GRIP_POSITION &&
        cameraViewId !== CameraViewId.INITIAL_3D_VIEW;
    var rotateClockwiseAction = {
        icon: EditButtonIcon.ROTATE_CLOCKWISE,
        action: function () {
            return dispatch(actions.setNodeRotation({
                nodeId: node.id,
                rotation: node.rotationY - 45,
            }));
        },
    };
    var rotateCounterClockwiseAction = {
        icon: EditButtonIcon.ROTATE_COUNTER_CLOCKWISE,
        action: function () {
            return dispatch(actions.setNodeRotation({
                nodeId: node.id,
                rotation: node.rotationY + 45,
            }));
        },
    };
    var deleteAction = {
        icon: EditButtonIcon.DELETE,
        action: function () { return dispatch(actions.deleteNode(node.id)); },
        isDelete: true,
    };
    var duplicateAction = {
        icon: EditButtonIcon.DUPLICATE,
        action: function () { return dispatch(actions.duplicateNode(node.id)); },
    };
    /* Many copies at once: arms the fill tool on this cup (a second click
     * disarms it). Offered under the same conditions as a single duplicate. */
    var fillAreaAction = {
        icon: EditButtonIcon.FILL_AREA,
        action: function () { return dispatch(actions.toggleCupFill(node.id)); },
        isActive: (cupFill === null || cupFill === void 0 ? void 0 : cupFill.anchorNodeId) === node.id,
    };
    var zoomAction = {
        icon: isZoomedIn ? EditButtonIcon.ZOOM_OUT : EditButtonIcon.ZOOM_IN,
        action: function () {
            dispatch(actions.setCameraView(isZoomedIn ? CameraViewId.EDIT_VIEW : CameraViewId.NODE_VIEW));
        },
    };
    var returnActions = [
        rotateCounterClockwiseAction,
        rotateClockwiseAction,
        canDuplicate ? duplicateAction : undefined,
        canFillArea ? fillAreaAction : undefined,
        zoomAction,
        node.type === NodeComponentType.FEED_PRESSURE_POINT
            ? undefined
            : deleteAction,
    ].filter(Boolean);
    return returnActions;
};
